import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const SiteofficeCreateForm= React.lazy(()=>import('./RegisterSiteoffice/index'))
const SiteofficeEditPage= React.lazy(()=>import('./EditSiteOffceForm/EditForm'));
const SiteofficeListingPage= React.lazy(()=>import('./SiteOfficeListing/index'))
const SiteofficeDetailPage= React.lazy(()=>import('./DetailSiteOfficepage/DetailPage'));


export const SiteOfficeConfigs = [
{
    permittedRole: [RoutePermittedRole.corporateAdmin],
    path: '/onboard-corporate/site-office/create',
    element: <SiteofficeCreateForm />,
  },
  {
    // permittedRole: [RoutePermittedRole.corporateAdmin],
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/site-office/listing',
    element: <SiteofficeListingPage />,
  },
  {
    permittedRole: [RoutePermittedRole.corporateAdmin, RoutePermittedRole.tenentAdmin],
    path: '/onboard-corporate/site-office/edit/:id',
    element: <SiteofficeEditPage />,
  },
  {
    permittedRole: [RoutePermittedRole.corporateAdmin, RoutePermittedRole.tenentAdmin],
    path: '/onboard-corporate/site-office/details/:id',
    element: <SiteofficeDetailPage/>,
  }
];